var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 25C8.5 22.5147 10.5147 20.5 13 20.5C15.4853 20.5 17.5 22.5147 17.5 25C17.5 27.4853 15.4853 29.5 13 29.5C10.5147 29.5 8.5 27.4853 8.5 25Z",
    fill: "white",
    stroke: "#73737B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19C19.5 16.5147 21.5147 14.5 24 14.5C26.4853 14.5 28.5 16.5147 28.5 19C28.5 21.4853 26.4853 23.5 24 23.5C21.5147 23.5 19.5 21.4853 19.5 19Z",
    fill: "white",
    stroke: "#73737B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 25C30.5 22.5147 32.5147 20.5 35 20.5C37.4853 20.5 39.5 22.5147 39.5 25C39.5 27.4853 37.4853 29.5 35 29.5C32.5147 29.5 30.5 27.4853 30.5 25Z",
    fill: "white",
    stroke: "#73737B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 32.5H10.5091C10.7719 25.276 16.7115 19.5 24 19.5C31.2885 19.5 37.2281 25.276 37.4909 32.5H24Z",
    fill: "#63C7C9",
    stroke: "#73737B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfCircle);
export default __webpack_public_path__ + "static/media/half-circle.6c461f27.svg";
export { ForwardRef as ReactComponent };